import { IntlShape } from 'react-intl';
import { MarketplaceInfo } from 'pages/insights-pro/marketplace-tab/model';

export const getIsOtherAwareArray = (
  allMarketplaces: MarketplaceInfo[],
  measures: string[],
  intl: IntlShape,
  finaliseOthers?: (others: MarketplaceInfo, countOthers: number) => MarketplaceInfo
) => {
  const standard = allMarketplaces.filter(c => !c.isOther);
  const isOthers = allMarketplaces.filter(c => c.isOther);

  if (isOthers.length > 0) {
    let grouped = allMarketplaces
      .filter(c => c.isOther)
      .reduce((acc, current) => {
        const measureEntries: Record<string, number> = measures
          .map(m => ({
            [m]: acc.entry.values[m] + current.entry.values[m],
          }))
          .reduce((l, r) => ({ ...l, ...r }));
        const compareMeasureEntries: Record<string, number> = measures
          .map(m => ({
            [m]:
              (acc.entry.compareValues ? (acc.entry.compareValues[m] ?? 0) : 0) +
              (current.entry.compareValues ? (current.entry.compareValues[m] ?? 0) : 0),
          }))
          .reduce((l, r) => ({ ...l, ...r }));
        return {
          ...acc,
          entry: {
            ...acc.entry,
            values: {
              ...acc.entry.values,
              ...measureEntries,
            },
            compareValues: {
              ...acc.entry.values,
              ...compareMeasureEntries,
            },
          },
        };
      });

    grouped.name = intl.formatMessage({
      id: 'groupby.others',
      defaultMessage: 'Others',
    });
    if (finaliseOthers) {
      grouped = finaliseOthers(grouped, isOthers.length);
    }
    return [...standard, grouped];
  }

  return standard;
};
